import { Map } from 'immutable';
import {getCookie} from '@iso/lib/helpers/session';

export function clearToken() {
  localStorage.removeItem('id_token');
}

export function getToken() {
  try {
    const idToken = localStorage.getItem('id_token');
    return new Map({ idToken });
  } catch (err) {
    clearToken();
    return new Map();
  }
}

export function arrayEqual(array1, array2) {
  return array1.sort().toString() === array2.sort().toString();
}

export function timeDifference(givenTime) {
  givenTime = new Date(givenTime);
  const milliseconds = new Date().getTime() - givenTime.getTime();
  const numberEnding = (number) => {
    return number > 1 ? 's' : '';
  };
  const number = (num) => (num > 9 ? '' + num : '0' + num);
  const getTime = () => {
    let temp = Math.floor(milliseconds / 1000);
    const years = Math.floor(temp / 31536000);
    if (years) {
      const month = number(givenTime.getUTCMonth() + 1);
      const day = number(givenTime.getUTCDate());
      const year = givenTime.getUTCFullYear() % 100;
      return `${day}-${month}-${year}`;
    }
    const days = Math.floor((temp %= 31536000) / 86400);
    if (days) {
      if (days < 28) {
        return days + ' day' + numberEnding(days);
      } else {
        const months = [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ];
        const month = months[givenTime.getUTCMonth()];
        const day = number(givenTime.getUTCDate());
        return `${day} ${month}`;
      }
    }
    const hours = Math.floor((temp %= 86400) / 3600);
    if (hours) {
      return `${hours} hour${numberEnding(hours)} ago`;
    }
    const minutes = Math.floor((temp %= 3600) / 60);
    if (minutes) {
      return `${minutes} minute${numberEnding(minutes)} ago`;
    }
    return 'a few seconds ago';
  };
  return getTime();
}
export async function postApi(endPoint, pojo) {
  // console.log('postApi pojo',pojo,endPoint)
  var apiResponse = await fetch(endPoint, {
    method: "post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      // authorization: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHBpcmVkQXQiOjE2OTc1MjA5OTE1MjIsIm5hbWUiOiJ1bmRlZmluZWQgdW5kZWZpbmVkIiwiaWQiOiI2NTI2M2ZkYzJlYTZmZmI4MjIyYmY0OTYiLCJyb2xlIjoiaW5jb2ZpbkFkbWluIiwic2hhcmVob2xkZXJObyI6IjEwMDAxIiwiaWF0IjoxNjk3NTIwMDkxfQ.QS-ldvv8J_Vi7gM32RXZAfmtyIwG_Veahfz1CDub3Q4",
      authorization: getCookie("id_token") ? getCookie("id_token") : "",
    },
    body: JSON.stringify(pojo),
  })
    .then(function (response) {
      return response.json();
    })
    .then((res) => {
      // if(res.success === false){
      //   let sendData = res.message;
      //   localStorage.setItem('errorMessage', sendData);
      //   window.location.href = '/404';
      // }
      // console.log('res', res)
      //const result = {};
      // console.log("res api", res);
      return res;
    })
    .catch((err) => {
      // console.error("Fetch post ERROR:", err);
    });
  if (apiResponse) {
    return apiResponse;
  } else {
    return {};
  }
}
export async function itsMePostApi(endPoint, pojo) {
  // console.log('postApi pojo',pojo,endPoint)
  var apiResponse = await fetch(endPoint, {
    method: "post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      // authorization: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHBpcmVkQXQiOjE2OTc1MjA5OTE1MjIsIm5hbWUiOiJ1bmRlZmluZWQgdW5kZWZpbmVkIiwiaWQiOiI2NTI2M2ZkYzJlYTZmZmI4MjIyYmY0OTYiLCJyb2xlIjoiaW5jb2ZpbkFkbWluIiwic2hhcmVob2xkZXJObyI6IjEwMDAxIiwiaWF0IjoxNjk3NTIwMDkxfQ.QS-ldvv8J_Vi7gM32RXZAfmtyIwG_Veahfz1CDub3Q4",
      authorization: getCookie("id_token") ? getCookie("id_token") : "",
    },
    body: JSON.stringify(pojo),
  })
    .then(function (response) {
      return response.json();
    })
    .then((res) => {
      if(res.success === false){
        let sendData = res.message;
        localStorage.setItem('errorMessage', sendData);
        window.location.href = '/404';
      }
      // console.log('res', res)
      //const result = {};
      // console.log("res api", res);
      return res;
    })
    .catch((err) => {
      // console.error("Fetch post ERROR:", err);
    });
  if (apiResponse) {
    return apiResponse;
  } else {
    return {};
  }
}
export async function postFormApi(endPoint, pojo) {
  // console.log('postApi pojo',pojo,endPoint)
  var apiResponse = await fetch(endPoint, {
    method: "post",
    headers: {
      // Accept: "application/json",
      // "Content-Type": "application/json",
      // authorization: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHBpcmVkQXQiOjE2OTc1MjA5OTE1MjIsIm5hbWUiOiJ1bmRlZmluZWQgdW5kZWZpbmVkIiwiaWQiOiI2NTI2M2ZkYzJlYTZmZmI4MjIyYmY0OTYiLCJyb2xlIjoiaW5jb2ZpbkFkbWluIiwic2hhcmVob2xkZXJObyI6IjEwMDAxIiwiaWF0IjoxNjk3NTIwMDkxfQ.QS-ldvv8J_Vi7gM32RXZAfmtyIwG_Veahfz1CDub3Q4",
      authorization: getCookie("id_token") ? getCookie("id_token") : "",
    },
    body: (pojo),
  })
    .then(function (response) {
      return response.json();
    })
    .catch((err) => {
      // console.error("Fetch post ERROR:", err);
    });
  if (apiResponse) {
    return apiResponse;
  } else {
    return {};
  }
}
export async function updateApi(endPoint, pojo) {
  var apiResponse = await fetch(endPoint, {
    method: "post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      // authorization: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHBpcmVkQXQiOjE2OTc1MzI1MDk4MDQsIm5hbWUiOiJ1bmRlZmluZWQgdW5kZWZpbmVkIiwiaWQiOiI2NTI2M2ZkYzJlYTZmZmI4MjIyYmY0OTYiLCJyb2xlIjoiaW5jb2ZpbkFkbWluIiwic2hhcmVob2xkZXJObyI6IjEwMDAxIiwiaWF0IjoxNjk3NTMxNjA5fQ.4Kgn0-KBh8sJOzTGF1ghlaiO7djFAraHFwEFYkB_-OY",
      authorization: getCookie("id_token") ? getCookie("id_token") : "",
    },
    body: JSON.stringify(pojo),
  })
    .then(function (response) {
      return response.json();
    })
    .catch((err) => {
      // console.error("Fetch post ERROR:", err);
    });
  if (apiResponse) {
    return apiResponse;
  } else {
    return {};
  }
}
export function getQueryStringFrmObject(param) {
  //make sure params contain info object
  var queryString = Object.keys(param.info)
    .map((key) => key + "=" + param.info[key])
    .join("&");
    // console.log('queryString', queryString)
  return queryString;
}
export async function getApi(endPoint, id) {
  let finalEndPoint = endPoint ? endPoint : "";
  if (id) {
    finalEndPoint = finalEndPoint + id;
  }
  var apiResponse = await fetch(finalEndPoint, {
    method: "get",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: getCookie("id_token") ? getCookie("id_token") : "",
      // authorization: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHBpcmVkQXQiOjE2OTg4OTg2MTMxNTQsIm5hbWUiOiJ1bmRlZmluZWQgdW5kZWZpbmVkIiwiaWQiOiI2NTI2M2ZkYzJlYTZmZmI4MjIyYmY0OTYiLCJyb2xlIjoiaW5jb2ZpbkFkbWluIiwic2hhcmVob2xkZXJObyI6IjEwMDAxIiwiaWF0IjoxNjk4ODk3NzEzfQ.wHAkoa6sA46u-6OPJg4DrwZPGjS1lmtTcgkLjNUQL44",
    },
  })
    .then(function (response) {
      return response.json();
    })
    .catch((err) => {
      // console.error("Fetch Get ERROR:", err);
    });
  if (apiResponse) {
    // console.log("finalEndPoint1111111", apiResponse);
    return apiResponse;
  } else {
    return {};
  }
}
export async function getShareConfigApi(endPoint, token) {
  let finalEndPoint = endPoint ? endPoint : "";
  var apiResponse = await fetch(finalEndPoint, {
    method: "get",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: token ? token : "",
      // authorization: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHBpcmVkQXQiOjE2OTg4OTg2MTMxNTQsIm5hbWUiOiJ1bmRlZmluZWQgdW5kZWZpbmVkIiwiaWQiOiI2NTI2M2ZkYzJlYTZmZmI4MjIyYmY0OTYiLCJyb2xlIjoiaW5jb2ZpbkFkbWluIiwic2hhcmVob2xkZXJObyI6IjEwMDAxIiwiaWF0IjoxNjk4ODk3NzEzfQ.wHAkoa6sA46u-6OPJg4DrwZPGjS1lmtTcgkLjNUQL44",
    },
  })
    .then(function (response) {
      return response.json();
    })
    .catch((err) => {
      // console.error("Fetch Get ERROR:", err);
    });
  if (apiResponse) {
     return apiResponse;
  } else {
    return {};
  }
}

export function stringToInt(value, defValue = 0) {
  if (!value) {
    return 0;
  } else if (!isNaN(value)) {
    return parseInt(value, 10);
  }
  return defValue;
}
export function stringToPosetiveInt(value, defValue = 0) {
  const val = stringToInt(value, defValue);
  return val > -1 ? val : defValue;
}

export function getQuery(url){
  let query = url?url.slice(1):null;
  query = query ? query.split('&'):null;
  var queryObj={}
  for(var i in query){
    let keys=query[i];
    keys = keys ? keys.split('='):null;
     var keyName=keys[0];
       queryObj[keyName]=keys[1]
    }
  //  console.log('query',queryObj);
return queryObj;
}
export function getFirstLastDayOfMonth(year, month, day, hr, min, sec) {
  return new Promise(async function (resolve, reject) {
    resolve(new Date(year, month, day, hr, min, sec).getTime());
  })
}
export function getTimeStampFromDate(date, time, start, end) {
  return new Promise(async function (resolve, reject) {
    if(date) {
      let dateArr = date.split("/");
      let dd = dateArr[0];
      let mm = dateArr[1];
      let yyyy = dateArr[2];
      let timeStamp = null;
      if(time) {
        let currentDateTime = new Date();
        let hrs = currentDateTime.getHours();
        let min = currentDateTime.getMinutes();
        let sec = currentDateTime.getSeconds();
        timeStamp = await getFirstLastDayOfMonth(yyyy, mm - 1, dd, hrs, min, sec);
      } else if (end) {
        timeStamp = await getFirstLastDayOfMonth(yyyy, mm - 1, dd, 23, 59, 59);
      } else if (start) {
        timeStamp = await getFirstLastDayOfMonth(yyyy, mm - 1, dd, 0, 0, 0);
      } else {
        timeStamp = await getFirstLastDayOfMonth(yyyy, mm - 1, dd, 0, 0, 0);
      }
      resolve(timeStamp);
    } else {
      resolve(null);
    }
  });
}

